import React, {useState} from 'react';
import './Login.css';

function Login({onLogin}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onLogin(username, password);
    };

    return (
        <div className={'mainContainer'}>

            <div className={'titleContainer'}>
                <div>Login</div>
            </div>
            <br/>
            <form onSubmit={handleSubmit}>
                <div className={'inputContainer'}>
                    <input
                        type="text"
                        placeholder="Enter your login here"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className={'inputBox'}
                        required
                    />
                </div>
                <div className={'inputContainer'}>
                    <input
                        type="password"
                        placeholder="Enter your password here"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={'inputBox'}
                        required
                    />
                </div>
                <div className={'inputContainer'}>
                    <button className={'inputButton'} type="submit">Login</button>
                </div>
            </form>
        </div>
    );
}

export default Login;